import { styled } from 'dripsy';
import React from 'react';
import { ViewProps } from 'react-native';

import { BaseText } from './BaseText';
import { Icon } from './Icon';
import { Touchable } from './Touchable';

const TouchableContainer = styled(Touchable)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: '$7',
  pr: '$6',
});

const Text = styled(BaseText)({
  variant: 'text.xlarge',
  py: '$3',
});

export interface INavigateButtonProps
  extends Omit<ViewProps, 'hitSlop'> {
  text: string;
  onPress: () => void;
}

export function NavigateButton({
  text,
  onPress,
  ...props
}: INavigateButtonProps) {
  return (
    <TouchableContainer onPress={onPress} {...props}>
      <Text>{text}</Text>
      <Icon name="arrow-right-light" size={24} />
    </TouchableContainer>
  );
}
